import loader from './loader'

const wizard = {
  el: {
    triggers: document.querySelectorAll<HTMLElement>(`a[href='#profid'], .wizard__background, .wizard__close-button`),
    inputs: document.querySelectorAll<HTMLInputElement>('.wizard__modal input'),
    modal: document.querySelector<HTMLFormElement>('.wizard__modal'),
    progressItems: document.querySelectorAll<HTMLElement>('.wizard__progress-item'),
    stepButtons: document.querySelectorAll<HTMLElement>('.wizard__buttons [data-go-to-step]'),
    submitButton: document.querySelector<HTMLButtonElement>(`.wizard__button[type='submit']`),
    subscriptionCheckbox: document.querySelector<HTMLInputElement>('#wizard-subscription-checkbox'),
    subscriptionInput: document.querySelector<HTMLInputElement>('#wizard-subscription'),
    wizard: document.querySelector<HTMLElement>('.wizard'),
  },

  init(): void {
    this.el.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.toggleWizard.bind(this))
    })

    this.el.stepButtons.forEach((stepButton) => {
      stepButton.addEventListener('click', () => {
        this.el.modal.dataset.currentStep = stepButton.dataset.goToStep
        this.handleProgress()
      })
    })

    this.handleProgress()
    this.handleStepButtons()
    this.handleSubscriptionCheckbox()

    this.el.modal.addEventListener('change', this.handleStepButtons.bind(this))
    this.el.modal.addEventListener('submit', this.submitWizard.bind(this))

    window.addEventListener('hashchange', this.toggleWizardOnHashChange.bind(this))
    this.toggleWizardOnHashChange(null)
  },

  closeOnEscPress(event): void {
    if (event.key.match('Escape') && this.el.wizard.classList.contains('wizard--active')) {
      this.toggleWizard(null)
    }
  },

  handleProgress(): void {
    this.el.progressItems.forEach((progressItem, index) => {
      if (Number.parseInt(this.el.modal.dataset.currentStep) > index + 1) {
        progressItem.classList.add('wizard__progress-item--active')
      } else {
        progressItem.classList.remove('wizard__progress-item--active')
      }
    })
  },

  handleStepButtons(): void {
    const currentStep = Number.parseInt(this.el.modal.dataset.currentStep)
    const inputs = this.el.modal.querySelectorAll(`.wizard__step[data-step='${currentStep}'] input`)
    const nextButton = this.el.modal.querySelector<HTMLButtonElement>(`.wizard__step[data-step='${currentStep}'] .wizard__button--next`)

    if (inputs.length < 1 || currentStep === 6) {
      return
    }

    let checkedInputs = 0

    inputs.forEach((input: HTMLInputElement) => {
      if (input.checked) {
        checkedInputs++
      }
    })

    if (checkedInputs > 0) {
      nextButton.disabled = false
    } else {
      nextButton.disabled = true
    }
  },

  handleSubscriptionCheckbox(): void {
    this.el.subscriptionCheckbox.addEventListener('change', (event) => {
      if ((event.target as HTMLInputElement).checked) {
        this.el.subscriptionInput.setAttribute('required', '')
      } else {
        this.el.subscriptionInput.removeAttribute('required')
      }
    })
  },

  submitWizard(event): void {
    event.preventDefault()

    const formData = new FormData(this.el.modal)
    const concatenatedValues = []

    formData.forEach((value) => {
      concatenatedValues.push(value)
    })

    const resultString = concatenatedValues.join(';')
    document.cookie = `wizardData=${encodeURIComponent(resultString)};path=/;max-age=3600`

    this.el.submitButton.classList.add('button--loading')
    this.el.submitButton.disabled = true
    this.el.wizard.classList.add('wizard--submitted')

    this.el.inputs.forEach((input: HTMLInputElement) => {
      input.value = ''
    })

    setTimeout(() => {
      const anchor = document.createElement('a')

      anchor.href = this.el.modal.getAttribute('action')
      this.el.wizard.classList.remove('wizard--active')

      loader.redirect(event, anchor)
    }, 789)
  },

  toggleWizard(event): void {
    event && event.preventDefault()

    if (this.el.wizard.classList.contains('wizard--active')) {
      this.el.wizard.classList.remove('wizard--active')
      this.el.modal.dataset.currentStep = '1'
      window.removeEventListener('keydown', this.closeOnEscPress.bind(this))
      if (window.location.hash === '#profid') {
        history.replaceState(null, null, window.location.href.split('#')[0])
      }
    } else {
      this.el.wizard.classList.add('wizard--active')
      window.addEventListener('keydown', this.closeOnEscPress.bind(this))
    }
  },

  toggleWizardOnHashChange(event): void {
    event && event.preventDefault()

    if (window.location.hash === '#profid') {
      this.toggleWizard(null)
    }
  },
}

export default wizard
